import { useEffect } from 'react'
import { useDeviceInfosStore } from '@/store/useDeviceInfosStore'

// Компонент для загрузки информации об устройстве в веб-среде
export const LoadDeviceInfos = () => {
  const setDeviceInfos = useDeviceInfosStore((state) => state.setDeviceInfos)

  useEffect(() => {
    // Получаем IP адрес пользователя (опционально)
    const getClientIP = async () => {
      try {
        // Используем бесплатный сервис для получения IP
        const response = await fetch('https://api.ipify.org?format=json')
        const data = await response.json()

        setDeviceInfos({
          real_ip: data.ip,
        })
      } catch (error) {
        // IP не критичен, продолжаем без него
      }
    }

    // Обновляем информацию о языке браузера
    const updateLanguage = () => {
      const language = navigator.language || 'en'
      setDeviceInfos({
        language: language.split('-')[0], // Берем только код языка
      })
    }

    // Получаем IP адрес
    getClientIP()

    // Обновляем язык
    updateLanguage()

    // Слушаем изменения языка браузера
    const handleLanguageChange = () => {
      updateLanguage()
    }

    window.addEventListener('languagechange', handleLanguageChange)

    return () => {
      window.removeEventListener('languagechange', handleLanguageChange)
    }
  }, []) // Убираем setDeviceInfos из зависимостей

  return null // Этот компонент не рендерит ничего
}
